<template>
  <div>
    <CCard>
      <CCardHeader>
        <CIcon name="cil-grid" />Tambah Group
      </CCardHeader>
      <CCardBody>
        <div class="form-group">
          <label>Nama</label>
          <input type="text" class="form-control" v-model="data.name" />
        </div>
      </CCardBody>
      <CCardFooter>
        <btn-save-update @save="save" @update="update" @back="goBack" :data="data"/>
      </CCardFooter>
    </CCard>
  </div>
</template>
<script>
import BtnSaveUpdate from "../../components/BtnSaveUpdate"
import { getErrorMessage } from "../../lib/helpers";
import { HTTPAUTH } from "../../lib/httplib";
export default {
  components: {
    BtnSaveUpdate,
  },
  data() {
    return {
      data: {},
      faculty: {},
    };
  },
  created() {
    var slug = "";
    const route = this.$route;
    if (route.params && route.params.slug) {
      slug = route.params.slug;
    } else {
      location.href = "#/master/study-program-group";
      return;
    }
    this.getList(slug);
  },
  methods: {
    getList(slug) {
      HTTPAUTH.get(`/api/v1/admin/study-program-group/${slug}`).then((res) => {
        this.data = res.data.data;
      });
    },
    save() {
      HTTPAUTH.post(`/api/v1/admin/study-program-group`, this.data)
        .then((res) => {
          this.$toasted.success("Data berhasil ditambahkan").goAway();
          this.data = {};
        })
        .catch((eres) => {
          this.$toasted.error(getErrorMessage(eres)).goAway();
        });
    },
    update() {
      HTTPAUTH.put(`/api/v1/admin/study-program-group/${this.data.id}`, this.data)
        .then((res) => {
          this.$toasted.success("Data berhasil ditambahkan").goAway();
          this.getList(this.data.slug);
        })
        .catch((eres) => {
          this.$toasted.error(getErrorMessage(eres)).goAway();
        });
    },
    goBack() {
      this.$router.push({path: "/master/study-program-group"})
    }
  },
};
</script>